import type {Impact} from "../types/signalsTypes";

const ORDER: Impact[] = ['high', 'medium', 'low'];

/** Whether `impact` is `threshold` or stronger (high > medium > low), as the server counts alerts. */
export function impactAtLeast(impact: Impact, threshold: Impact): boolean {
    return ORDER.indexOf(impact) <= ORDER.indexOf(threshold);
}
